import Home from './features/home/pages/Home/Home';
import Login from './features/auth/pages/Login/login';

import AllPost from './features/hadith/pages/AllPost/AllPost';
import NewPost from './features/hadith/pages/AllPost/NewPost';
import EditPost from './features/hadith/pages/AllPost/EditPost';
import Draft from './features/hadith/pages/Draft/Draft';
import Hadith from './features/hadith/pages/Hadith/Hadith';
import NewPosts from './features/hadith/pages/NewPosts/NewPosts';

import AddArticle from './features/articles/pages/AddArticle';

import AddBook from './features/books/pages/AddBook/AddBook';
import BookVollumes from './features/books/pages/BookVollumes/BookVollumes';

import Categories from './features/categories/pages/Categories/Categories';
import ParentCategory from './features/categories/pages/ParentCategory/ParentCategory';

import AccountSetting from './features/settings/pages/AccountSetting/AccountSetting';

export const routesArr = [
  {
    name: 'Content',
    active: true,
    route: '/',
    component: <Home />,
    display: true,
  },
  {
    name: 'Login',
    active: true,
    route: '/login',
    component: <Login />,
    display: false,
  },
  {
    name: 'All Posts',
    active: false,
    route: '/all-posts',
    component: <AllPost />,
    display: true,
  },
  {
    name: 'Drafts',
    active: false,
    route: '/draft',
    component: <Draft />,
    display: true,
  },
  {
    name: 'News Posts',
    active: false,
    route: '/new-posts',
    component: <NewPosts />,
    display: true,
  },
  {
    name: 'Hadith of the day',
    active: false,
    route: '/hadith-of-the-day',
    component: <Hadith />,
    display: true,
  },
  {
    name: 'Account Settings',
    active: false,
    route: '/account-setting',
    component: <AccountSetting />,
    display: true,
  },
  {
    name: 'New Post',
    active: false,
    route: '/new-post',
    component: <NewPost />,
    display: false,
  },
  {
    name: 'New Post',
    active: false,
    route: '/edit-post',
    component: <EditPost />,
    display: false,
  },
  {
    name: 'New Book',
    active: false,
    route: '/book/add-book',
    component: <AddBook />,
    display: false,
  },
  {
    name: 'Book Volumes',
    active: false,
    route: '/book/book-Volumes',
    component: <BookVollumes />,
    display: false,
  },
  {
    name: 'Table Of Content Book',
    active: false,
    route: '/book/table-of-content',
    component: <BookVollumes />,
    display: false,
  },
  {
    name: 'New Article',
    active: false,
    route: '/article/add-article',
    component: <AddArticle />,
    display: false,
  },
  {
    name: 'parent category',
    active: false,
    route: '/book/parent-category',
    component: <ParentCategory />,
    display: false,
  },
  {
    name: 'category',
    active: false,
    route: '/book/category',
    component: <Categories />,
    display: false,
  },
];
